import { Button, ButtonText } from '@/components/ui/button'
import { Center } from '@/components/ui/center'
import { Text } from '@/components/ui/text'
import useCopyText from '@/components/useCopyText'
import useCustomTabBarHeight from '@/lib/hooks/useCustomTabBarHeight'
import useHorizontalSafeAreaPadding from '@/lib/hooks/useHorizontalSafeAreaPadding'
import { Image, ScrollView } from 'react-native'

const PC_TRADE_URL = `${process.env.EXPO_PUBLIC_NEXT_BASE_URL}/trade`

export default function TradeMerchantEmpty() {
  const copyText = useCopyText()
  const customTabBarHeight = useCustomTabBarHeight()
  const horizontalPadding = useHorizontalSafeAreaPadding()

  return (
    <ScrollView
      contentInsetAdjustmentBehavior="automatic"
      contentContainerStyle={{ ...horizontalPadding, paddingBottom: customTabBarHeight + 24 }}
    >
      {/* flexGrow would center within the ScrollView's full frame, ignoring the header and tab bar insets iOS adds */}
      <Center className="min-h-[60vh] py-6">
        <Image
          source={require('@/assets/images/no_result.png')}
          style={{ width: 160, height: 160, marginBottom: 16 }}
          resizeMode="contain"
        />
        <Text className="text-label text-lg font-semibold text-center px-8">免费入驻，马上收款</Text>
        <Text className="text-secondary-label text-base text-center mt-1 px-8">卖课程、卖门票、收报名费都能用</Text>
        <Text className="text-secondary-label text-base text-center mt-10 px-8">
          你还没有商户号，请到电脑上申请或绑定直连商户号
        </Text>
        <Button
          variant="outline"
          className="mt-8 rounded-lg border-opaque-separator"
          onPress={() => copyText(PC_TRADE_URL)}
        >
          <ButtonText className="text-label font-normal">复制电脑端链接</ButtonText>
        </Button>
      </Center>
    </ScrollView>
  )
}
